<template>
    <div>
        <v-card flat class="score-trans">
            <v-container fluid class="ma-0 pa-0">
                <div class="dflex">
                    <div class="small-font mt-3">
                        <i>Average score based upon {{ this.summary.total_reviews_pub }} published reviews:</i>
                    </div>
                    <div align="right">
                        <v-avatar class="review-avatar" size="75">
                            <span class="av-font">{{ this.summary.total_average_score_pub }}<br />
                                <div class="small-font">{{ this.summary.exact_total_average_pub }}</div>
                            </span>
                        </v-avatar>
                    </div>
                </div>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    export default {     
        mounted() {
            this.load(); 
        },            
        data() {
            return {
                summary: {},
            }
        },           
        methods: {       
            load(){ 
                console.log('(re) load left panel review summary data');
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getReviewSummaryv1.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getReviewSummary"
                        },
                        getReviewSummary: {}
                    })
                    .then(res => {
                        res.data.error ? console.log(res.data.error) : this.summary = res.data.getReviewSummary;
                    })
            },       
       }             
    }
</script>

<style scoped>
    .av-font {
        font-size: 30px;
        font-weight: bold;
    }    
    .review-avatar {
        background: transparent !important;
        border: 2px solid green;
    }  
    .small-font{
        font-size: 12px !important;
    }    
    .score-trans {
        background: transparent !important;
    }
    .dflex{
        display:flex;
    }

</style>